import React, { useState, useEffect } from 'react';
import CreateGallary from './CreateGallary'; 
import CreateTable from './CreateTable'; 
import { getAllGalleries } from '../../../services/operations/GALLARYAPI';

const GalleryManagement = () => {
    const [selectedGallery, setSelectedGallery] = useState(null);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [galleries, setGalleries] = useState([]);

    useEffect(() => {
        const fetchGalleries = async () => {
            const data = await getAllGalleries();
            setGalleries(data);
        };
        fetchGalleries();
    }, []);

    const handleFormSuccess = async () => {
        setIsFormVisible(false);
        setSelectedGallery(null);
        // Refresh galleries after form submission
        const data = await getAllGalleries();
        setGalleries(data);
    };

    return (
        <div>
            <h1>Gallery Management</h1>
            {isFormVisible && (
                <CreateGallary
                    galleryId={selectedGallery?._id}
                    existingData={selectedGallery}
                    onSuccess={handleFormSuccess}
                />
            )}
            <button onClick={() => {
                setIsFormVisible(true);
                setSelectedGallery(null); // Ensure no existing gallery is selected when adding new
            }}>
                {selectedGallery ? "Edit Gallery" : "Add New Gallery"}
            </button>
            <CreateTable
                onEdit={(gallery) => {
                    setSelectedGallery(gallery);
                    setIsFormVisible(true);
                }}
                onDelete={handleFormSuccess} // Refresh the table after deletion
            />
        </div>
    );
};

export default GalleryManagement;
